import React from "react";
import "./ChartLegend.scss";

const ChartLegend = () => {
	return (
		<div className="sap-journey-chart-legend">
			<div>
				<div>
					<div className="legend-key sap-score-legend" />
					<span>Your Average SAP</span>
					<div className="legend-key sap-count-legend" />
					<span>No. of Updates</span>
				</div>
			</div>
		</div>
	);
};

export default ChartLegend;
